import { CloseIcon } from "vega-icons";

import type { BannerResponse } from "@vega-api/generated/types/bannerResponse";
import { Notice } from "@vega-core/components/Notice/Notice";
import { resolveVegaIcon } from "@vega-modules/utils/resolveVegaIcon";

import { resolveBannerNoticeType } from "./resolveBannerNoticeType";

type ConfigBannerProps = {
  banner: BannerResponse | null;
  dismissedIds: string[];
  onDismiss: (bannerId: string) => void;
  sticky?: boolean;
};

export const ConfigBanner = ({
  banner,
  dismissedIds,
  onDismiss,
  sticky = true,
}: ConfigBannerProps) => {
  if (!banner || dismissedIds.includes(banner.id)) {
    return null;
  }

  const { content } = banner;

  return (
    <Notice
      className={sticky ? undefined : "absolute pointer-events-none"}
      content={
        <span className="flex min-w-0 items-center gap-2">
          <span className="shrink-0 body-base-semibold">{content.heading}</span>
          {content.description ? (
            <>
              <span className="h-4 w-px shrink-0 bg-border/primary" />
              <span className="min-w-0 truncate body-base-regular text-text/secondary">
                {content.description}
              </span>
            </>
          ) : null}
        </span>
      }
      dataTestId="config-banner"
      expandable={false}
      icon={resolveVegaIcon(content.icon)}
      leftIcon={<CloseIcon className="h-6 w-6" />}
      onClose={() => onDismiss(banner.id)}
      sticky={sticky}
      type={resolveBannerNoticeType(content.variant)}
      variant="topBar"
    />
  );
};
